import React from 'react'
import PropTypes from 'prop-types'

import theme from 'theme_'

export default function BatteryIcon({
  charge = 0,
  inactive = false,
  color = theme.colors.beachGrey,
}) {
  const chargeHeight = Math.round(charge) * 0.01 * 12.2
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="Mask">
        <rect
          x="3.903"
          y="-18.29"
          width="15.835"
          height={chargeHeight}
          strokeWidth={0}
          fillRule="nonzero"
          fill="rgb(255, 255, 255)"
          id="Mask"
          transform="matrix(1, 0, 0, -1, 0, 0)"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M 8.753 8.062 L 15 8.062 L 15 6.1 L 17.664 6.1 L 17.664 8.062 L 19.454 8.062 L 19.454 18.26 L 4.3 18.26 L 4.3 8.062 L 6.089 8.062 L 6.089 6.1 L 8.753 6.1 L 8.753 8.062 Z"
        paintOrder="fill"
        fill={color}
        mask="url(#Mask)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.08942 5.74425C5.08942 5.34947 5.453 5.1001 5.7809 5.1001H9.06559C9.39738 5.1001 9.75333 5.35285 9.75333 5.74425V7.06179H14.0003V5.74425C14.0003 5.35286 14.3562 5.1001 14.688 5.1001H17.9727C18.3006 5.1001 18.6642 5.34947 18.6642 5.74425V7.06179H19.7847C20.1324 7.06179 20.4538 7.32538 20.4538 7.70251V18.6158C20.4538 18.993 20.1285 19.2599 19.7809 19.2599H3.96891C3.61718 19.2599 3.2998 18.9892 3.2998 18.6158V7.69317C3.30718 7.31825 3.62742 7.06179 3.97264 7.06179H5.08942V5.74425ZM5.68907 5.74744C5.68905 5.74744 5.68909 5.74716 5.68927 5.74664L5.68907 5.74744ZM5.68927 5.74664C5.69026 5.7441 5.69385 5.73731 5.70433 5.72826C5.72361 5.71161 5.75236 5.7001 5.7809 5.7001H9.06559C9.09376 5.7001 9.12091 5.71132 9.13882 5.72699C9.14964 5.73645 9.15262 5.74304 9.15333 5.74532V7.36179C9.15333 7.52747 9.28764 7.66179 9.45333 7.66179H14.3003C14.466 7.66179 14.6003 7.52747 14.6003 7.36179V5.74532C14.601 5.74304 14.604 5.73645 14.6148 5.72699C14.6327 5.71132 14.6598 5.7001 14.688 5.7001H17.9727C18.0013 5.7001 18.03 5.71161 18.0493 5.72825C18.0598 5.73731 18.0632 5.7437 18.0642 5.74623V7.36179C18.0642 7.52747 18.1985 7.66179 18.3642 7.66179H19.7847C19.8129 7.66179 19.8323 7.672 19.8427 7.68161C19.8525 7.69072 19.8538 7.69785 19.8538 7.70251V18.6158C19.8538 18.6187 19.853 18.6271 19.8408 18.6384C19.8283 18.6499 19.8076 18.6599 19.7809 18.6599H3.96891C3.94262 18.6599 3.9236 18.6502 3.91247 18.6398C3.90154 18.6296 3.8998 18.621 3.8998 18.6158V7.7036C3.9002 7.6976 3.90259 7.69041 3.91188 7.68201C3.92253 7.67239 3.94264 7.66179 3.97264 7.66179H5.38942C5.55511 7.66179 5.68942 7.52747 5.68942 7.36179L5.68927 5.74664ZM18.0645 5.74744C18.0645 5.74745 18.0643 5.7468 18.0642 5.74623L18.0645 5.74744ZM14.6001 5.74619C14.6001 5.74618 14.6001 5.74576 14.6003 5.74532L14.6001 5.74619ZM9.15351 5.74619C9.15349 5.7462 9.15337 5.74577 9.15333 5.74532L9.15351 5.74619Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M 12.591 12.575 L 12.591 8.975 L 9.591 13.775 L 11.391 13.775 L 11.391 17.375 L 14.391 12.575 L 12.591 12.575 Z"
        paintOrder="stroke"
        strokeMiterlimit={50}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.6}
        stroke="rgb(255, 255, 255)"
        fill={color}
        visibility={inactive ? 'hidden' : 'visible'}
      />
    </svg>
  )
}

BatteryIcon.propTypes = {
  charge: PropTypes.number,
  inactive: PropTypes.bool,
  color: PropTypes.string,
}
